var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import * as Atoms from "./atoms";
import { breakPointArrayCleaner } from "../../utils";

export var Grid = function Grid(props) {
  return React.createElement(
    Atoms.Grid,
    props,
    props.children
  );
};

Grid.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  flexDirection: PropTypes.string,
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
  gap: PropTypes.bool
} : {};

Grid.defaultProps = {
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: false
};

var Box = function Box(props) {
  var width = props.width,
      order = props.order,
      hide = props.hide,
      alignItems = props.alignItems,
      $as = props.$as,
      restProps = _objectWithoutProperties(props, ["width", "order", "hide", "alignItems", "$as"]);

  return React.createElement(
    Atoms.Box,
    _extends({
      className: "grid-box",
      width: breakPointArrayCleaner(width),
      order: breakPointArrayCleaner(order),
      hide: breakPointArrayCleaner(hide),
      alignItems: breakPointArrayCleaner(alignItems),
      $as: $as
    }, restProps),
    props.children
  );
};

Box.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  $as: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  hide: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.bool)]),
  alignItems: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
} : {};

// TODO: add proptypes

Box.defaultProps = {
  width: 1,
  order: 1,
  hide: false,
  alignItems: "flex-start",
  $as: "div"
};

Grid.Box = Box;